import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const Welcome = () => {
  const navigate = useNavigate();

  const handleShopAccess = () => {
    navigate('/homepage');
  };

  // Animation des particules flottantes
  const FloatingParticles = () => {
    return (
      <div className="absolute inset-0 z-10 pointer-events-none">
        {[...Array(30)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-1 h-1 bg-[#00ffc3] rounded-full"
            initial={{
              x: Math.random() * window.innerWidth,
              y: Math.random() * window.innerHeight,
              opacity: 0
            }}
            animate={{
              y: [null, -100],
              opacity: [0, 0.8, 0]
            }}
            transition={{
              duration: Math.random() * 3 + 2,
              repeat: Infinity,
              delay: Math.random() * 2,
              ease: "linear"
            }}
          />
        ))}
      </div>
    );
  };

  // États pour contrôler les animations
  const [showAccess, setShowAccess] = useState(false);

  // Démarrer les animations en séquence
  useEffect(() => {
    const accessTimer = setTimeout(() => setShowAccess(true), 500);
    
    return () => {
      clearTimeout(accessTimer);
    };
  }, []);

  return (
    <div className="welcome-container relative overflow-hidden bg-[url('/telephone.png')] md:bg-[url('/pc.png')] bg-[position:50%_50%] md:bg-[position:55%_50%] bg-no-repeat min-h-screen bg-[length:auto_100%] md:bg-[length:100%_auto]">
      
      <FloatingParticles />
      
      <div className="absolute inset-0 flex flex-col items-center justify-center text-white z-20 text-center">
        <AnimatePresence>
            {showAccess && (
                <motion.div
                    className="mt-72 mr-10"
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1, x: -2 }}
                    transition={{ duration: 0.8, ease: 'easeOut' }}
                >
                    <motion.button
                        onClick={handleShopAccess}
                        className="bg-gradient-to-r from-[#00ffc3] to-[#00aaff] text-black font-bold text-xl py-4 px-12 rounded-full shadow-lg transform transition-all duration-300 ease-in-out hover:scale-110 hover:shadow-2xl focus:outline-none"
                        whileTap={{ scale: 0.95 }}
                        animate={{
                            y: ["0%", "-10%", "0%"],
                        }}
                        transition={{
                            y: {
                                duration: 2,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "easeInOut"
                            }
                        }}
                    >
                        Accéder à la boutique
                    </motion.button>
                </motion.div>
            )}
        </AnimatePresence>
    </div>
    </div>
  );
};

export default Welcome;